import { ProductListViewModel, ProductViewModel } from '@/types/api'

import { WishlistType } from '@/features/webengage/types'
import { productNameSizeHandler } from '@/features/webengage/utils/product-name-size-handler'

import { getActiveExperiments } from '../experiments/get-active-experiments'
import { SingleEvent } from '../third-party-scripts/response-data-validator'

export const getEnabledEvents = (eventsList: SingleEvent[]) =>
    new Set(eventsList.filter((e) => e.enabled).map((e) => e.name))

export function convertToFavoriteData(
    product: ProductListViewModel | ProductViewModel | undefined,
    { truncateProductName = false }: { truncateProductName?: boolean } = {}
): WishlistType {
    const productName = product?.nameFa ?? ''
    const [item_category1, item_category2, item_category3] = (product?.breadcrumb ?? [])
        .map((category) => category?.nameFa)
        .filter((name): name is string => typeof name === 'string' && name.trim() !== '')

    const salesPrice = product && 'salesPrice' in product ? product.salesPrice : undefined
    const effectivePrice = product && 'effectivePrice' in product ? product.effectivePrice : undefined

    return {
        product_id: product?.id ?? '',
        product_name: truncateProductName ? productNameSizeHandler(productName) : productName,
        product_brand: product?.brand?.nameFa ?? '',
        value: salesPrice ?? effectivePrice ?? 0,
        ...(item_category1 ? { item_category1 } : {}),
        ...(item_category2 ? { item_category2 } : {}),
        ...(item_category3 ? { item_category3 } : {}),
    }
}

export const userExperiments = () => {
    const experiments = getActiveExperiments()
    const formattedExperiments = experiments.map((exp) => ({
        experiment_id: exp.id,
        experiment_title: exp.title,
        experiment_version: exp.version,
    }))
    return {
        experiment: experiments.length > 0 ? formattedExperiments : null,
    }
}
